import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import { BRAND_NAME } from '@/mocks/categories';

const navItems = [
  { label: '首页', to: '/' },
  { label: '电影', to: '/category/movie' },
  { label: '电视剧', to: '/category/tv' },
  { label: '综艺', to: '/category/variety' },
  { label: '纪录片', to: '/category/documentary' },
  { label: '搜索', to: '/search' },
  { label: '关于我们', to: '/about' },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 bg-background-50 border-b transition-colors duration-300 ${
        scrolled ? 'border-background-300' : 'border-background-200'
      }`}
    >
      <div className="flex items-center justify-between h-16 px-4 md:px-8">
        <Link to="/" className="flex items-center gap-2 shrink-0 group">
          <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
            <i className="ri-film-line text-xl"></i>
          </span>
          <span className="font-heading text-lg font-bold text-foreground-950 whitespace-nowrap">
            {BRAND_NAME}
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) =>
                `px-3 py-2 text-sm rounded-md whitespace-nowrap transition-colors ${
                  isActive
                    ? 'text-primary-500 font-semibold bg-primary-50'
                    : 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            type="button"
            aria-label="搜索"
            onClick={() => navigate('/search')}
            className="hidden md:flex w-9 h-9 items-center justify-center rounded-md border border-background-300 text-foreground-700 hover:text-accent-500 hover:border-accent-300 transition-colors cursor-pointer"
          >
            <i className="ri-search-line text-lg"></i>
          </button>
          <Link
            to="/contact"
            className="hidden md:inline-flex items-center gap-1 h-9 px-4 rounded-md bg-accent-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-accent-600 transition-colors"
          >
            <i className="ri-mail-send-line"></i>
            联系
          </Link>
          <button
            type="button"
            aria-label="菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className="lg:hidden w-9 h-9 flex items-center justify-center rounded-md border border-background-300 text-foreground-800 cursor-pointer"
          >
            <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 py-3 animate-fade-in">
          <div className="grid grid-cols-2 gap-2">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) =>
                  `px-3 py-3 text-sm rounded-md text-center whitespace-nowrap transition-colors ${
                    isActive
                      ? 'bg-primary-50 text-primary-500 font-semibold'
                      : 'bg-background-100 text-foreground-700'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </div>
          <Link
            to="/contact"
            className="mt-3 flex items-center justify-center gap-1 h-11 rounded-md bg-accent-500 text-background-50 text-sm font-medium"
          >
            <i className="ri-mail-send-line"></i>
            联系我们
          </Link>
        </div>
      )}
    </header>
  );
}